import { createContext, useContext } from 'react';

/**
 * Contexto cuando Preview/View se montan dentro del popup de búsqueda integrada.
 * - nested=false → navegación normal (rutas, NavbarIcons, Link a preview/view).
 * - nested=true → sin NavbarIcons; Versión completa/resumida cambia detailMode in-place.
 */
export const IntegrationNestedPreviewContext = createContext({
  nested: false,
  detailMode: 'preview', // 'preview' | 'view'
  setDetailMode: null,
});

export const useIntegrationNestedPreview = () => {
  const ctx = useContext(IntegrationNestedPreviewContext);
  if (ctx == null || typeof ctx !== 'object') {
    return { nested: !!ctx, detailMode: 'preview', setDetailMode: null };
  }
  return {
    nested: !!ctx.nested,
    detailMode: ctx.detailMode === 'view' ? 'view' : 'preview',
    setDetailMode: typeof ctx.setDetailMode === 'function' ? ctx.setDetailMode : null,
  };
};
